import { VStack } from "goi_common";
import Image from "next/image";

interface SlideItemProps {
  src: string;
  name: string;
  height: string;
}

const SlideItem = ({ src, name, height }: SlideItemProps) => {
  return (
    <VStack
      position="relative"
      width="100%"
      height={height}
      alignItems="center"
      justifyContent="center"
    >
      <Image
        fill
        priority={true}
        alt={name}
        loading="eager"
        style={{ objectFit: "cover", objectPosition: "center" }}
        src={src}
      />
    </VStack>
  );
};

export default SlideItem;
